import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { sanitizeTelemetry } from './telemetryPrivacy';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: {
            
          }
        }
    }
});

if (process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING) {
  appInsights.addTelemetryInitializer(sanitizeTelemetry);
  appInsights.loadAppInsights();
}

export { reactPlugin, appInsights };
